import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="禁漫天堂 – 官方入口与完整使用指南"
        description="禁漫天堂是深受用户喜爱的成人漫画平台，本页提供禁漫天堂最新访问入口、注册登录教程、内容分类导览及常见问题解答，帮助用户快速、安全地访问禁漫天堂并畅享全站资源。"
        keywords="禁漫天堂,禁漫天堂入口,禁漫天堂最新地址,禁漫天堂注册教程,禁漫天堂APP下载,禁漫天堂镜像站,禁漫天堂VIP会员"
        canonicalPath="/"
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '禁漫天堂 – 官方入口与完整使用指南',
            description: '禁漫天堂是深受用户喜爱的成人漫画平台，本页提供禁漫天堂最新访问入口、注册登录教程、内容分类导览及常见问题解答。',
            url: 'https://jmtthub.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '禁漫天堂',
              url: 'https://jmtthub.com',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '禁漫天堂是否需要注册才能使用？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '浏览漫画列表和部分免费内容不需要注册。但如果您希望收藏漫画、发表评论、使用离线下载等功能，则需要注册账号。注册完全免费，过程简单快捷。',
                },
              },
              {
                '@type': 'Question',
                name: '禁漫天堂是否安全？如何保护个人隐私？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '禁漫天堂高度重视用户隐私安全，采用业界标准的加密技术保护用户数据。所有数据传输均经过加密处理。',
                },
              },
              {
                '@type': 'Question',
                name: '如果访问不了禁漫天堂怎么办？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '可以尝试使用镜像站点、切换网络环境、使用VPN服务或下载APP客户端访问。',
                },
              },
            ],
          },
        ]}
      />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}